import { Loadable } from '../../components/common/loadable/loadable';

export const FLowsLazyContainer = Loadable<any>({
  loader: () =>
    import(/* webpackChunkName: "flows" */ './flows.container').then(
      (module) => module.FlowsContainer,
    ),
});
